module.exports = __webpack_public_path__ + "img/product-xsteacher-intro.aa837914.png";